import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SalService } from 'src/app/Services/sal/sal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentviewmodelComponent } from '../paymentviewmodel/paymentviewmodel.component';

@Component({
  selector: 'app-sale-payment',
  templateUrl: './sale-payment.component.html',
  styleUrls: ['./sale-payment.component.css']
})
export class SalePaymentComponent implements OnInit {

 
  Submitted:boolean=false;
   Action:any="Add";
  constructor(private modalService: NgbModal,private Productservice: SalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }
 
    SaleModel = {         
      IsActive: true,     
      PaymentID:0,
      CustomerID:this.globalHelper.GetLoginToken().SchoolID,
      ToDate:'',
      FromDate:'',
      ReceiptNo:'',
      InvoiceNo:'',
      PaymentStatus:""
  };
  PaymentList:any;
  GetPayment(PaymentStatus) {
  
    this.SaleModel.PaymentStatus=PaymentStatus;
   
    this.spinnerService.show();
      this.Productservice.GetAllReceipt(JSON.stringify(this.SaleModel)).subscribe((response: any) => {
          this.PaymentList = response.PaymentList;
          this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(response);
      });
  };
  ItemList:any;
  Details:any;
  SumTotalTax:any;
  TotalAmount:any;

    PaymentDetails:any;
    ViewPayment(item) {
      
      this.PaymentDetails=item;  
    
     const modalRef = this.modalService.open(PaymentviewmodelComponent, { size:'xl' });
     modalRef.componentInstance.PaymentDetails = this.PaymentDetails;
   
     modalRef.result.then((result) => {
       if (result) {
         console.log(result);
       }
     });
 
 
   }



  Clear = function () {
      this.Action="Add";
      this.SaleModel.CustomerID = 0;
      this.SaleModel.InvoiceNo = "";
      this.SaleModel.ReceiptNo = '';
      this.SaleModel.FromDate = '';
      this.SaleModel.ToDate = '';    
      this.ProductDescription='';
      this.SaleModel.IsActive = true;
      this.Submitted = false;    
      this.GetPayment(); 
  };

  // PaymentMarkActive(obj){
  //   this.SaleModel.PaymentID = obj.PaymentID;  
  //   this.SaleModel.IsActive = obj.IsActive == true ? false : true;
  //   this.spinnerService.show();
  //   this.Productservice.ProductMarkActive(JSON.stringify(this.SaleModel)).subscribe((response: any) => {
  //     this.spinnerService.hide();
  //       if (response.webResponse.Status) {
  //           this.Clear();
  //       }
  //       this.GetPayment(0);
  //       this.globalHelper.CheckActionStatus(response);
  //   });
  // }
 
  Edit(obj) {
    this.Action="Edit";
      this.SaleModel.PaymentID = obj.PaymentID;
      this.SaleModel.CustomerID = obj.CustomerID;      
      this.SaleModel.IsActive = obj.IsActive;
  
  };
  CustomerList:any;
  GetCustomer() {
    this.lookupservice.GetLookupsList('Customer', '').subscribe((data: any) => {
      this.CustomerList = data.LookupItems;
      
    });
  };
ngOnInit() {
//  this.GetCustomer();
// this.GetPayment(0);
  }
}
